<template>
    <div class="locale-changer">
        <v-select
            v-model="selectedLang"
            :items="langs"
            @change="changeLanguage"
            hide-details
            dense
            outlined
        ></v-select>
    </div>
</template>

<script>
export default {
    name: 'LocaleChanger',
    data () {
        return {
            langs: ['pt-BR', 'en-US', 'es-ES'],
            selectedLang: this.getInitialLocale(), // Define o idioma inicial ao carregar a página
            initialLoad: true
        }
    },
    mounted () {
        // Define o idioma inicial quando o componente é montado
        this.changeLanguage(this.selectedLang, false)
        this.initialLoad = false // Define a flag como falsa após o primeiro carregamento
    },
    watch: {
        selectedLang (newLocale) {
            if (!this.initialLoad) {
                // Somente altera o idioma e recarrega a rota se não for a carga inicial
                this.changeLanguage(newLocale, true)
            }
        }
    },
    methods: {
        getInitialLocale () {
            // Verifica o localStorage para recuperar o idioma salvo
            const storedLocale = localStorage.getItem('locale')
            return storedLocale || this.$i18n.locale // Se não houver, retorna o idioma padrão
        },
        changeLanguage (newLocale, shouldReload = true) {
            // Atualiza o idioma no i18n
            const vueLocales = {
                'pt-BR': 'pt',
                'en-US': 'en',
                'es-ES': 'es'
            }
            this.$i18n.locale = newLocale
            this.$vuetify.lang.current = vueLocales[newLocale]
            // Armazena a escolha do usuário no localStorage
            localStorage.setItem('locale', newLocale)
            if (shouldReload) {
                // Recarrega a rota apenas se o idioma realmente foi alterado
                // this.$router.push({ name: this.$route.name }).catch(e => {})
                window.location.reload()
            }
        }
    }
}
</script>

<style scoped>
.locale-changer {
    display: flex;
    justify-content: center;
    margin: 0 10px;
    max-width: 100px;
}
</style>
